"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Wrapper = _interopRequireDefault(require("../Wrapper"));
var _usePickerState2 = _interopRequireDefault(require("../usePickerState"));
var _DateSelection = _interopRequireDefault(require("./DateSelection"));
var _Icon = require("../../Icon");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["value", "onChange", "format", "minDate", "maxDate", "disablePast", "disableFuture", "shouldDisableDate", "showDaysOutsideCurrentMonth", "view", "disabled", "actions", "withTodayButton", "error"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var DEFAULT_MIN_DATE = new Date('1900-01-01');
var DEFAULT_MAX_DATE = new Date('2100-01-01');
var DatePicker = function DatePicker(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    format = _ref.format,
    _ref$minDate = _ref.minDate,
    minDate = _ref$minDate === void 0 ? DEFAULT_MIN_DATE : _ref$minDate,
    _ref$maxDate = _ref.maxDate,
    maxDate = _ref$maxDate === void 0 ? DEFAULT_MAX_DATE : _ref$maxDate,
    disablePast = _ref.disablePast,
    disableFuture = _ref.disableFuture,
    shouldDisableDate = _ref.shouldDisableDate,
    showDaysOutsideCurrentMonth = _ref.showDaysOutsideCurrentMonth,
    view = _ref.view,
    disabled = _ref.disabled,
    actions = _ref.actions,
    _ref$withTodayButton = _ref.withTodayButton,
    withTodayButton = _ref$withTodayButton === void 0 ? true : _ref$withTodayButton,
    error = _ref.error,
    restPropsForTextField = _objectWithoutProperties(_ref, _excluded);
  var _usePickerState = (0, _usePickerState2["default"])({
      value: value,
      onChange: onChange,
      format: format,
      autoApply: true,
      disabled: disabled
    }),
    wrapperProps = _usePickerState.wrapperProps,
    inputProps = _usePickerState.inputProps,
    pickerProps = _usePickerState.pickerProps;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Wrapper["default"], _objectSpread(_objectSpread({}, wrapperProps), {}, {
    error: error,
    DateInputProps: _objectSpread(_objectSpread(_objectSpread({
      disabled: disabled,
      actions: actions
    }, inputProps), restPropsForTextField), {}, {
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.InsertInvitationIcon, {})
    }),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DateSelection["default"], {
      view: view,
      value: pickerProps.value,
      onChange: pickerProps.onChange,
      minDate: minDate,
      maxDate: maxDate,
      disablePast: disablePast,
      disableFuture: disableFuture,
      shouldDisableDate: shouldDisableDate,
      showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
      withTodayButton: withTodayButton
    })
  }));
};
var _default = exports["default"] = DatePicker;